module.exports = __webpack_public_path__ + "img/corporate_building_dark.90cf035c.svg";